import { baseStyles } from '../../../../shared/control-room-render/render-core.mjs';

/**
 * Bridge between the shared Control Room render core and the Foundry cockpit.
 * The core emits HTML/SVG strings themed by --cr-* variables; this scope maps
 * them onto Foundry tokens and injects the core's baseline CSS once. The pack
 * does the same mapping onto the member's detected brand — one implementation,
 * two skins (the eng-review DRY mandate).
 */
const TOKEN_BRIDGE = `
.cr-scope{
  --cr-bg: var(--fd-bg);
  --cr-surface: var(--fd-paper);
  --cr-surface-2: var(--fd-surface-1);
  --cr-line: var(--fd-border);
  --cr-line-strong: var(--fd-border);
  --cr-text: var(--fd-text);
  --cr-muted: var(--fd-text-muted);
  --cr-quiet: var(--fd-text-subtle);
  --cr-primary: var(--fd-accent);
  --cr-on-primary: oklch(0.16 0.005 95);
  --cr-primary-soft: var(--fd-accent-soft);
  --cr-accent: var(--fd-teal);
  --cr-bad: var(--fd-coral);
}
.cr-scope .cr-module{border-radius:12px}
`;

export function ControlRoomStyles() {
  return <style>{TOKEN_BRIDGE + baseStyles()}</style>;
}

/** Render a core-emitted string inside the Foundry token scope. */
export function CoreHtml({
  html,
  onRefClick,
  onRefHover,
  onRouteClick,
  className,
}: {
  html: string;
  onRefClick?: (ref: string) => void;
  onRefHover?: (ref: string | null) => void;
  onRouteClick?: (id: string) => void;
  className?: string;
}) {
  return (
    <div
      className={`cr-scope ${className ?? ''}`}
      // Core output is self-generated and fully escaped — never user input.
      dangerouslySetInnerHTML={{ __html: html }}
      onClick={(e) => {
        const t = e.target as HTMLElement;
        const route = t.closest?.('[data-route]')?.getAttribute('data-route');
        if (route && onRouteClick) return onRouteClick(route);
        const ref = t.closest?.('[data-ref]')?.getAttribute('data-ref');
        if (ref && onRefClick) onRefClick(ref);
      }}
      onMouseOver={(e) => {
        if (!onRefHover) return;
        const ref = (e.target as HTMLElement).closest?.('[data-ref]')?.getAttribute('data-ref');
        if (ref) onRefHover(ref);
      }}
      onMouseOut={(e) => {
        if (!onRefHover) return;
        if ((e.target as HTMLElement).closest?.('[data-ref]')) onRefHover(null);
      }}
    />
  );
}
